import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { ProdPayMasterSheetInterface } from '@vatos-pas/common';
import { CAN_PAID_PHASE } from 'providers/permissions';
import SharedPaidStatusField, {
  hasPaidHistory,
} from 'components/PaidStatusField';
import {
  buildMarkAsPaidBody,
  PROD_PAY_MARK_AS_PAID_RESOURCE,
} from '../selection';

/** The Prod Payables row fields the Paid? column reads. */
export type ProdPayPaidStatusRow = Pick<
  ProdPayMasterSheetInterface,
  'id' | 'isPaid' | 'countPaidHistory' | 'phaseName' | 'jobLot'
>;

type ProdPayPaidStatusFieldProps = PublicFieldProps &
  InjectedFieldProps<ProdPayPaidStatusRow>;

/**
 * Prod Payables MS Paid? column. The view exposes the current state as
 * `isPaid`; every toggle writes one history entry `{ jobPhaseId, paid }` to
 * job-phase-paid.
 */
const PaidStatusField = ({ record }: ProdPayPaidStatusFieldProps) => {
  if (!record) return null;

  return (
    <SharedPaidStatusField
      id={record.id}
      paid={!!record.isPaid}
      hasHistory={hasPaidHistory(record.countPaidHistory)}
      historyResource="/job-phase-paid"
      foreignKeyName="jobPhaseId"
      editPermission={CAN_PAID_PHASE}
      title="Payment Status History"
      subtitle={`${record.phaseName} - Lot # ${record.jobLot}`}
      markAsPaid={{
        resource: PROD_PAY_MARK_AS_PAID_RESOURCE,
        body: buildMarkAsPaidBody([record.id]),
      }}
    />
  );
};

export default PaidStatusField;
